const backToTop = document.querySelector('.back-to-top');

window.addEventListener('scroll', function(){
  if (window.scrollY > window.innerHeight) {
    backToTop.classList.add('is-active');
  } else {
    backToTop.classList.remove('is-active');
  }
});

function initPage() {
  const filtersWrapper = document.querySelector('.v2-filters-wrapper');

  window.addEventListener('click', function(){
    filtersWrapper.classList.remove('is-active');
  });

  document.querySelector('.v2-filters-trigger').addEventListener('click', function(e){
    e.stopPropagation();
    filtersWrapper.classList.toggle('is-active');
  });

  document.querySelector('.v2-filters-drawer').addEventListener('click', function(e){
    e.stopPropagation();
  });

  document.querySelector('.v2-filters-close').addEventListener('click', function(){
    filtersWrapper.classList.remove('is-active');
  });

  const filterOptions = {
    category: [],
    color: [],
    type: [],
  };

  const filterableItems = document.querySelectorAll('.filterable-item');

  filterableItems.forEach((item) => {
    const handle = item.getAttribute('data-handle');
    const itemCategories = (item.getAttribute('data-category') || '').trim().split(',');
    const itemColor = (item.getAttribute('data-color') || '').trim();
    const itemTypes = (item.getAttribute('data-type') || '').trim().split(',');

    itemCategories.forEach((itemCategory) => {
      if (itemCategory && !filterOptions.category.includes(itemCategory)) {
        filterOptions.category.push(itemCategory);
      }
    });
    
    if (itemColor && !filterOptions.color.includes(itemColor)) {
      filterOptions.color.push(itemColor);
    }

    itemTypes.forEach((itemType) => {
      if (itemType && !itemType.startsWith('__') && !filterOptions.type.includes(itemType)) {
        filterOptions.type.push(itemType);
      }
    });

    item.addEventListener('click', () => {
      const viewed = (localStorage.getItem('v2a-viewed') || '').split(',').filter((item) => item);
      viewed.push(handle);

      localStorage.setItem('v2a-clicked', handle);
      localStorage.setItem('v2a-scroll', window.scrollY);
      localStorage.setItem('v2a-viewed', viewed.join(','));
      localStorage.setItem('v2a-history', Array.from(document.querySelectorAll('.filterable-item:not(.v2-hidden)')).map(e => e.getAttribute('data-handle')).join(','));
    });

    const viewed = (localStorage.getItem('v2a-viewed') || '').split(',').filter((item) => item);
    if (viewed.includes(handle)) {
      item.classList.add('is-viewed');
    }
  });

  filterOptions.category.sort();
  filterOptions.color.sort();
  filterOptions.type.sort();

  const v2Filters = document.querySelector('.v2-filters');

  document.querySelector('.filter-recent').addEventListener('click', (element) => {
    document.querySelector('.grid-v2a').classList.toggle('is-only-recent');
  });

  v2Filters.querySelectorAll('.v2-filters-options').forEach((element) => {
    const type = element.getAttribute('data-type');

    filterOptions[type].forEach((option) => {
      element.innerHTML = 
        element.innerHTML + 
        `<li>
          <label>
            <input 
              type="${type === 'color' ? 'radio' : 'checkbox'}" name="${type}" value="${option}" 
            />
            ${
              type === 'color' 
              ? `<span class="v2-swatch" data-option="${option}" style="background: ${option.replace('dark', '#333')};">
                ${
                  option === 'patchwork'
                  ? `<svg width="264" height="264" viewBox="0 0 264 264" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <mask id="mask0_642_2759" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="264" height="264">
                    <circle cx="132" cy="132" r="132" fill="#D9D9D9"></circle>
                    </mask>
                    <g mask="url(#mask0_642_2759)">
                    <rect x="132" y="-58.9189" width="135" height="135" transform="rotate(45 132 -58.9189)" fill="#F64740"></rect>
                    <rect x="227.459" y="36.54" width="135" height="135" transform="rotate(45 227.459 36.54)" fill="#F5DF4C"></rect>
                    <rect x="-58.9189" y="-58.9189" width="135" height="135" transform="rotate(45 -58.9189 -58.9189)" fill="#D9D9D9"></rect>
                    <rect x="36.54" y="36.54" width="135" height="135" transform="rotate(45 36.54 36.54)" fill="#4A68D9"></rect>
                    <rect x="132" y="132" width="135" height="135" transform="rotate(45 132 132)" fill="#63A8AC"></rect>
                    <rect x="227.459" y="227.459" width="135" height="135" transform="rotate(45 227.459 227.459)" fill="#D9D9D9"></rect>
                    </g>
                  </svg>`
                  : ''
                }
              </span>` 
              : `<span>${ type === 'category' ? (option[0].toUpperCase() + option.substring(1)) : option}</span>`
            }
          </label>
        </li>
        `;
    });
  });

  v2Filters.querySelectorAll('.v2-filters-options[data-type="category"] li').forEach((li) => {
    const categoryName = li.querySelector('label span').innerHTML.trim();
    const categoryHandle = categoryName.toLowerCase();

    li.innerHTML += `<ul class="v2-filters-options" data-type="type" data-category="${categoryHandle}">
      <li>
        <label>
          <input type="checkbox" name="type" value="is_all_${categoryHandle}">
          All ${categoryName}
        </label>
      </li>
    </ul>`;

    const label = li.querySelector('label');

    label.innerHTML += '<span class="v2-toggle-symbol v2-toggle-plus"></span><span class="v2-toggle-symbol v2-toggle-minus"></span>';
    label.querySelector('input').remove();
    label.addEventListener('click', () => {
      label.classList.toggle('is-expanded');
    });
  });

  v2Filters.querySelectorAll('.v2-filters-options[data-type="type"]').forEach((element) => {
    const type = element.getAttribute('data-type');
    const category = element.getAttribute('data-category');

    filterOptions[type].forEach((option) => {
      let text = ''
      const pieces = option.split('__');

      if (pieces.length > 1) {
        text = pieces[1];
      }

      if (pieces[0] === category) {
        element.innerHTML += `<li>
            <label>
              <input type="checkbox" name="${type}" value="${option}" />
              ${text}
            </label>
          </li>
        `;
      }
    });
  });

  const v2FiltersOptions = v2Filters.querySelectorAll('input[type=checkbox], input[type=radio]');

  const toggleFilters = () => {
    /*v2FiltersOptions.forEach((checkbox) => {
      checkbox.parentElement.classList.remove('v2-hidden');

      if (checkbox.name === 'price') {
      } else {
        const match = document.querySelector(`.filterable-item[data-${checkbox.name}="${checkbox.value}"]:not(.v2-hidden)`);

        if (!match) {
          checkbox.parentElement.classList.add('v2-hidden');
        }
      }
    });*/
  }

  toggleFilters();

  /*v2Filters.querySelector('.v2-swatch-text').addEventListener('click', () => {
    v2Filters.querySelectorAll('.v2-filters-colors input').forEach((input) => {
      input.checked = false;
    });

    const event = new Event('change');
    v2Filters.querySelector('.v2-filters-colors input').dispatchEvent(event);
  });*/

  v2Filters.querySelectorAll('.v2-toggle-label').forEach((label) => {
    label.addEventListener('click', () => {
      label.classList.toggle('is-expanded');
    });
  });

  v2FiltersOptions.forEach((checkbox) => {
    if (checkbox.name === 'category') {
      return;
    } 

    checkbox.addEventListener('change', (event) => {
      const target  = event.target;

      if (target.value.startsWith('is_all_')) {
        const siblings = target.parentElement.parentElement.parentElement.querySelectorAll('li');

        siblings.forEach((sibling, index) => {
          const checkbox = sibling.querySelector('input');

          if (checkbox !== target) {
            checkbox.checked = target.checked;

            if (siblings.length - 1 === index) {
              const event = new Event('change');
              checkbox.dispatchEvent(event);
            }
          }
        });

        return;
      }

      const selection = {
        category: [],
        color: [],
        price: [],
        type: [],
        discount: []
      };

      document.querySelector('.grid-v2a').classList.remove('is-only-recent');
      window.scrollTo(0, document.querySelector('.main-collection__scroll-anchor').offsetTop + 80)

      v2FiltersOptions.forEach((checkbox) => {
        if (checkbox.checked && checkbox.value !== 'all') {
          selection[checkbox.name].push(checkbox.value);
        }
      });

      const filterCount = selection.category.length + selection.price.length + selection.type.length + selection.discount.length;

      document.querySelector('.v2-filters-trigger').setAttribute(
        'data-count', 
        filterCount > 0 ? `(${filterCount})` : ''
      );

      localStorage.setItem('v2a-selection', JSON.stringify(selection));

      filterableItems.forEach((item) => {
        item.classList.remove('v2-hidden');

        for (filter in selection) {
          const selectionTypeOptions = selection[filter];

          if (selectionTypeOptions.length) {
            const itemValue = (item.getAttribute(`data-${filter}`) || '').trim();

            if (filter === 'price' && false) {
              let isMatch = false;
              const itemPrice = parseInt(itemValue || 0);

              selectionTypeOptions.forEach((option) => {
                const optionPieces = option.split('-');
                const min = parseInt(optionPieces[0]);
                const max = parseInt(optionPieces[1]);

                if (itemPrice >= min && itemPrice <= max) {
                  isMatch = true;
                }
              });

              if (!isMatch) {
                item.classList.add('v2-hidden');
              }
            } else if (['type', 'discount', 'price'].includes(filter)) {
              let isMatch = false;
              const itemValueArr = itemValue.split(',');

              itemValueArr.forEach((value) => {
                if (selectionTypeOptions.includes(value)) {
                  isMatch = true;
                }
              });

              if (!isMatch) {
                item.classList.add('v2-hidden');
              }
            } else if (!selectionTypeOptions.includes(itemValue)) {
              item.classList.add('v2-hidden');
            }
          }
        }
      });

      toggleFilters();
    });
  });

  if (window.location.href.includes('?back')) {
    let previousSelection = localStorage.getItem('v2a-selection');

    if (previousSelection) {
      previousSelection = JSON.parse(previousSelection);

      for (let i in previousSelection) {
        for (let j in previousSelection[i]) {
          const target = v2Filters.querySelector(`input[name="${i}"][value="${previousSelection[i][j]}"]`);

          if (target) {
            target.click();
          }
        }
      }
    }

    /*let viewedHandle = localStorage.getItem('v2a-clicked');

    if (viewedHandle) {
      const viewedItem = document.querySelector(`.filterable-item[data-handle="${viewedHandle}"]`);

      if (viewedItem) {
        const v2Recent = document.querySelector('.v2-recent');

        if (v2Recent) {
          v2Recent.classList.add('is-active');
          v2Recent.querySelector('img').src = viewedItem.querySelector('.product-tile__media img:first-child').src || viewedItem.querySelector('.product-tile__media img:first-child').getAttribute('data-src');
          v2Recent.querySelector('.v2-recent-title').innerHTML = viewedItem.querySelector('.product-tile__header .product-tile__title').innerHTML;
          v2Recent.querySelector('.v2-recent-price').innerHTML = viewedItem.querySelector('.product-tile__price-wrap').innerHTML;
          v2Recent.querySelector('a').href = viewedItem.querySelector('a').href;
          v2Recent.querySelector('button').addEventListener('click', function(){
            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              mode: 'cors',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                items: [{ id: viewedItem.getAttribute('data-variantid'), quantity: 1 }]
              }),
            }).then((response) => {
              document.dispatchEvent(new CustomEvent('refreshcart'));
            });
          });
        }
      }
    }*/
  }
}

if (localStorage.getItem('v2a-scroll')) {
  window.scrollTo(0, localStorage.getItem('v2a-scroll'));
}

fetch('/collections/' + window.collectionHandle + '?page=2').then((response) => {
  return response.text();
}).then((html) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');
  const holder = doc.querySelector('[data-collection-products]');

  document.querySelector('[data-collection-products]').insertAdjacentHTML('beforeend', holder.innerHTML);

  if (localStorage.getItem('v2a-scroll')) {
    window.scrollTo(0, localStorage.getItem('v2a-scroll'));
  }

  fetch('/collections/' + window.collectionHandle + '?page=3').then((response) => {
    return response.text();
  }).then((html) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    const holder = doc.querySelector('[data-collection-products]');

    document.querySelector('[data-collection-products]').insertAdjacentHTML('beforeend', holder.innerHTML);

    initPage();

    if (localStorage.getItem('v2a-scroll')) {
      window.scrollTo(0, localStorage.getItem('v2a-scroll'));
      localStorage.removeItem('v2a-scroll');
    }
  });
}); 

function initQuickAtc() {
	const quickAtc = document.querySelector('.quick-atc');

	if (quickAtc) {
		quickAtc.querySelector('.quick-atc-close').addEventListener('click', () => {
			quickAtc.classList.remove('is-active');
		});

		quickAtc.querySelector('.quick-atc-button button').addEventListener('click', () => {
			window.noQuickAtc = true;
			window.quickAtcTile.querySelector('form button').click();
			window.noQuickAtc = false;
			quickAtc.classList.remove('is-active');
      setTimeout(() => document.dispatchEvent(new CustomEvent('refreshcart')));
		});

		window.startQuickAtc = (form) => {
			window.quickAtcTile = form.parentNode.parentNode;

			fetch(window.quickAtcTile.href).then((response) => {
		    return response.text();
		  }).then((html) => {
		    const parser = new DOMParser();
		    const doc = parser.parseFromString(html, 'text/html');

        quickAtc.querySelector('[data-product-main-gallery]').innerHTML = doc.querySelector('[data-product-main-gallery]').innerHTML;
        quickAtc.querySelector('[data-product-thumbs-gallery]').innerHTML = doc.querySelector('[data-product-thumbs-gallery]').innerHTML;
		    quickAtc.querySelector('.quick-atc-title').innerHTML = doc.querySelector('[data-product-title]').innerHTML;
		    quickAtc.querySelector('.quick-atc-price').innerHTML = doc.querySelector('.main-product__price-wrap').innerHTML;
        quickAtc.querySelector('.quick-atc-reviews').innerHTML = doc.querySelector('.main-product-header__stars').innerHTML;
        quickAtc.querySelector('.quick-atc-icons').innerHTML = doc.querySelector('.pdp-icons').innerHTML;
		    quickAtc.querySelector('.quick-atc-view a').href = window.quickAtcTile.href;
		    quickAtc.classList.add('is-active');

        const newQuickAtc = doc.querySelector('.quick-atc-msg');
        const startAt = newQuickAtc.getAttribute('data-start');
        const endAt = newQuickAtc.getAttribute('data-end');
        const startObj = new Date(parseInt(`${startAt}000`));
        const endObj = new Date(parseInt(`${endAt}000`));

        if (startObj < new Date() && endObj > new Date()) {
          quickAtc.querySelector('.quick-atc-msg').innerHTML = newQuickAtc.innerHTML;
        } else if (!startAt && !endAt) {
          quickAtc.querySelector('.quick-atc-msg').innerHTML = newQuickAtc.innerHTML;
        }

        const mainGalleryEl = quickAtc.querySelector('[data-product-main-gallery]');
        const thumbsEl = quickAtc.querySelector('[data-product-thumbs-gallery]');

        if (mainGalleryEl && thumbsEl) {
          mainGalleryEl.querySelectorAll('img, source').forEach((media) => {
            media.src = media.getAttribute('data-src') || media.src;
          });

          thumbsEl.querySelectorAll('img').forEach((image) => {
            image.src = image.getAttribute('data-src') || image.src;
          });

          const quickAtcSlider = quickAtc.querySelector('.quick-atc-slider');
          quickAtcSlider.innerHTML = '';
          mainGalleryEl.querySelectorAll('img').forEach((image) => {
            quickAtcSlider.innerHTML = quickAtcSlider.innerHTML + `<img src="${image.src}" />`;
          });

          const mainGallery = new Splide('[data-product-main-gallery]', {
            direction: 'ltr',
            pagination: true,
            arrows: true,
            type: 'loop',
            noDrag: 'model-viewer, .product-media__model',
            start: 0,
            perPage: 1,
            snap: true
          });

          const thumbs = new Splide('[data-product-thumbs-gallery]', {
            perPage: 5,
            direction: 'ltr',
            pagination: false,
            isNavigation: true,
            arrows: true,
            gap: 6,
            focus: 1,
            trimSpace: true,
            rewind: true,
            mediaQuery: 'min',
            breakpoints: {
              1024: {
                focus: 0,
                fixedWidth: 55,
              }
            }
          });

          mainGallery.sync(thumbs);
          mainGallery.mount();
          thumbs.mount();
          mainGallery.refresh();
        }
		  });
		}
	}
}

initQuickAtc();
